import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '../../ui/button';
import { DeliveryAddressFields } from '../../tax/DeliveryAddressFields';
import { TaxExplainLine } from '../../tax/TaxBadges';
import { HelpLink } from '../HelpLink';

const API = process.env.REACT_APP_BACKEND_URL;

// Admin tool: resolve one delivery/service address to its jurisdiction and rate (never guesses)
export const AddressTaxCheck = ({ token }) => {
  const [addr, setAddr] = useState({ street: '', city: '', state: 'NY', zip: '' });
  const [res, setRes] = useState(null);
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      const r = await axios.post(`${API}/api/admin/tax/address-check`, { destination: addr, subtotal: 1000 }, { headers: { Authorization: `Bearer ${token}` } });
      setRes(r.data);
    } catch (e) { toast.error(e.response?.data?.detail || 'Address check failed'); } finally { setBusy(false); }
  };
  const d = res?.tax_details;
  const j = d?.jurisdiction;
  return (
    <div className="bg-white border rounded-lg p-4 space-y-3" data-testid="address-tax-check">
      <p className="text-sm font-medium flex items-center gap-2">Address Tax Check <HelpLink topic="tax-how-calculated" /></p>
      <DeliveryAddressFields value={addr} onChange={setAddr} testId="address-check" />
      <Button size="sm" onClick={run} disabled={busy} data-testid="address-check-run">{busy ? 'Checking…' : 'Check address'}</Button>
      {res && (
        <div className="border-t pt-3 space-y-2 text-sm" data-testid="address-check-result">
          <TaxExplainLine doc={res} testId="address-check-explain" />
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 text-xs">
            <div><p className="text-neutral-500">Resolved jurisdiction</p><p className="font-medium" data-testid="address-check-jurisdiction">{j?.name || (d.status === 'pending_address' ? 'Tax to be confirmed' : '—')}</p></div>
            <div><p className="text-neutral-500">Tax rate</p><p className="font-medium" data-testid="address-check-rate">{d.rate == null ? 'Tax to be confirmed' : `${d.rate}%`}</p></div>
            <div><p className="text-neutral-500">Jurisdiction code</p><p className="font-medium" data-testid="address-check-code">{j?.code || '—'}</p></div>
            <div><p className="text-neutral-500">Matched address</p><p className="font-medium">{j?.matched_address || '—'}</p></div>
          </div>
          <ol className="text-xs text-neutral-600 space-y-0.5 list-none" data-testid="address-check-steps">
            {(d.steps || []).map((s) => <li key={s}>{s}</li>)}
          </ol>
          <p className="text-[11px] text-neutral-400">Example on a $1,000 subtotal. Exemptions and overrides are applied per customer/order, not here.</p>
        </div>
      )}
    </div>
  );
};
